import { Reducer } from "react";

// TeamBuilder 게임 상태 관리 리듀서
// 1인용으로 서버 통신 없이 로컬에서 모든 처리

export interface TeamAssignment {
  playerNumber: number; // 1, 2, 3...
  teamNumber: number; // 1, 2, 3...
}

export interface TeamBuilderState {
  // 게임 설정
  totalPlayers: number; // 총 인원 수
  teamCount: number; // 팀 개수

  // 게임 상태
  started: boolean;

  // 결과
  assignments: TeamAssignment[];
}

export type TeamBuilderAction =
  | { type: "SET_TOTAL_PLAYERS"; count: number }
  | { type: "SET_TEAM_COUNT"; count: number }
  | { type: "START_TEAM_BUILDING" } // 팀 편성 시작 및 배정
  | { type: "RESET" };

export const initialTeamBuilderState: TeamBuilderState = {
  totalPlayers: 8,
  teamCount: 2,
  started: false,
  assignments: [],
};

// 팀 배정 로직
const assignTeams = (
  totalPlayers: number,
  teamCount: number
): TeamAssignment[] => {
  const assignments: TeamAssignment[] = [];

  // 플레이어 번호 배열 생성 (1부터 시작)
  const playerNumbers = Array.from({ length: totalPlayers }, (_, i) => i + 1);

  // Fisher-Yates shuffle로 플레이어 순서 섞기
  for (let i = playerNumbers.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [playerNumbers[i], playerNumbers[j]] = [playerNumbers[j], playerNumbers[i]];
  }

  // 팀에 순차적으로 배정
  playerNumbers.forEach((playerNumber, index) => {
    const teamNumber = (index % teamCount) + 1;
    assignments.push({
      playerNumber,
      teamNumber,
    });
  });

  // 플레이어 번호 순으로 정렬
  assignments.sort((a, b) => a.playerNumber - b.playerNumber);

  return assignments;
};

export const teamBuilderReducer: Reducer<TeamBuilderState, TeamBuilderAction> =
  (state, action) => {
    switch (action.type) {
      case "SET_TOTAL_PLAYERS":
        return {
          ...state,
          totalPlayers: Math.max(1, action.count),
          started: false, // 설정 변경 시 게임 초기화
        };
      case "SET_TEAM_COUNT":
        return {
          ...state,
          teamCount: Math.max(1, Math.min(action.count, state.totalPlayers)), // 팀 개수는 최대 인원 수만큼
          started: false, // 설정 변경 시 게임 초기화
        };
      case "START_TEAM_BUILDING":
        const assignments = assignTeams(state.totalPlayers, state.teamCount);
        return {
          ...state,
          started: true,
          assignments,
        };
      case "RESET":
        return {
          ...initialTeamBuilderState,
          totalPlayers: state.totalPlayers,
          teamCount: state.teamCount,
        };
      default:
        return state;
    }
  };
